// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M9Zk","comment":"styles_comment__18doK"};